document.addEventListener('alpine:init', () => {
  Alpine.data('ProductSiblings', () => ({
    $self: null,
    $productSection: null,
    flags: {
      isQuickView: false,
    },
    collection_handle: '',
    active_product: '',
    products: {},
    init() {
      this.InitWatchers();
      this.InitSelf();
    },
    InitSelf() {
      this.$self = this.$el;
      this.$productSection = this.$el.closest('.product-section');
      this.active_product = this.$el.dataset.active_product;
      this.collection_handle = this.$el.dataset.collection;
      if (this.$el.closest('.modal--quick-shop.modal--is-active')) {
        this.flags.isQuickView = true;
      }
      // console.log('ProductSiblings initialized:', this.$el);
    },
    InitWatchers() {
      // load section when product is changed
      this.$watch('active_product', Alpine.debounce(() => {
        if (!this.active_product) {
          console.error('No active_product set!');
          return;
        }
        console.log('active_product changed:', this.active_product);
        this.e_RenderProduct(this.active_product);
      }), 300);

      document.addEventListener('variant:change', (e) => {
        this.$el.dataset.selected_options = JSON.stringify(e.detail.variant.options);
      });
    },
    async loadProductSection(product_handle) {
      if (!product_handle) {
        console.log('No product handle provided for loading product section.');
        return;
      }
      // console.log(this, this.$el)
      let collection_handle = this.collection_handle;
      let section_id = this.$productSection.dataset.sectionId;
      let new_url = '';
      if (collection_handle) {
        new_url = `/collections/${collection_handle}`;
      }
      new_url += `/products/${product_handle}`;
      new_url += `?section_id=${section_id}`;
      if (this.flags.isQuickView) {
        new_url += `&view=modal`;
      }

      // set variant with same size
      let variant = this.GetVariant();
      if (variant) {
        new_url += `&variant=${variant.id}`;
      }

      const response = await fetch(new_url);
      const text = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'text/html');
      let $productSection = doc.querySelector(`[data-section-id="${section_id}"]`);
      return $productSection;
    },
    async e_RenderProduct() {
      const product_handle = this.active_product;
      if (!product_handle) {
        console.log('No product handle provided.');
        return;
      }
      const collection_handle = this.collection_handle;
      let new_url = '';
      if (collection_handle) {
        new_url = `/collections/${collection_handle}`;
      }
      new_url += `/products/${product_handle}`;

      // set variant with same size
      let variant = this.GetVariant();
      if (variant) {
        new_url += `?&variant=${variant.id}`;
      }

      // Avoid re-rendering the same product
      if (this.$productSection.dataset.productUrl.split('/').pop() == product_handle) return;

      let $newSection = await this.loadProductSection(product_handle);

      console.log(window.hcOriginalPrice)
      window.hcOriginalPrice = new HCOriginalPrice(window.hcOriginalPriceSettings);
      window.hcOriginalPrice.init();

      this.$productSection.replaceWith($newSection);
      if (!this.flags.isQuickView) {
        history.replaceState(null, '', new_url);
        theme.sections.register('product', theme.Product);
      }
      else {
        let $holder = this.$productSection.parentElement;
        theme.sections.register('product', theme.Product, $holder);
        document.dispatchEvent(new CustomEvent('reinit-quickview-product'));
      }
    },

    GetVariant() {
      // set variant with same size
      let $product = this.$el.querySelector(`[data-product-handle="${this.active_product}"]`);
      let product_data = JSON.parse($product.dataset.product);
      let selected_options = JSON.parse(this.$el.dataset.selected_options);
      let variant = product_data.variants.find(v => {
        return v.options.every((opt, index) => {
          return opt === selected_options[index];
        });
      });
      return variant;
    }
  }));

  Alpine.data('ColorSiblingItem', () => ({
    e_SwitchImage() {
      let $sibling = this.$el;
      let $product = $sibling.closest('.grid-product');
      let $image = $sibling.querySelector('image-element');
      
      [...$product.querySelectorAll('.grid-product__secondary-image image-element')].forEach($img => {
        $img.replaceWith($image.cloneNode(true));
      });
      AOS.refreshHard();
    }
  }));

  Alpine.data('Swiper', () => ({
    swiper: null,
    init() {
      this.InitSelf();
    },
    InitSelf() {
      let $swiper = this.$el.querySelector('.swiper');
      let config = JSON.parse($swiper.dataset.swiper_config) || {};

      if (this.$el.querySelector('.swiper-button-next') && this.$el.querySelector('.swiper-button-prev')) {
        config['navigation'] = {
          nextEl: this.$el.querySelector('.swiper-button-next'),
          prevEl: this.$el.querySelector('.swiper-button-prev'),
        };
      }

      // get current slide index from active sibling
      let $active = this.$el.querySelector('[data-active]');
      if ($active) {
        let $slide = $active.closest('.swiper-slide');
        let index = $slide.dataset.index || 0;
        // get page number from slides per view
        config.initialSlide = index;
      }

      config.on = {
        init: () => {
          let swiper = $swiper.swiper;
          // console.log(swiper);
          if (swiper.slides.length <= swiper.params.slidesPerView) {
            $swiper.classList.add('swiper-no-slides');
          }
        },
        slideChange: () => {
          // console.log('Slide changed to index:', this.swiper.activeIndex);
        }
      }
      // console.log(config, $swiper);
      this.swiper = new Swiper($swiper, config);

      // console.log('Swiper initialized:', this.swiper);
    }
  }));

  tippy('[data-tippy-content]');
});
